<div class="row justify-content-between align-items-center">
    <div class="col-md-12 d-flex justify-content-center align-items-center">
        <share-button theme="circles-dark" button="whatsapp" text="Share" shareButton="facebook" [url]="this.productUrl"
            [image]="product.image" [description]="product.title" [title]="product.title"></share-button>

        <share-button theme="circles-dark" button="facebook" text="Compartir" shareButton="facebook"
            [url]="this.productUrl" [image]="product.image" [description]="product.title"
            [title]="product.title"></share-button>
    </div>
</div>